import RegisterForm from '../features/auth/components/RegisterForm';

export default function RegisterPage() {
  return <RegisterForm />;
}
